import {type FunctionalComponent, h, type VNode} from '@stencil/core';

import type {GuidedV2ResultGroup} from '../../models/quick-link';



/**
 * Functional component that renders a list of guided search results.
 *
 * @param {GuidedV2ResultGroup} params - The parameters for the result list.
 * @returns {VNode | []} The rendered result list or an empty array if no links are provided.
 */
export const GuidedV2ResultListSection: FunctionalComponent<
  Omit<GuidedV2ResultGroup,'showWhen'|'type'>
  //exclude showWhen and type as they are checked one level higher
>
  = (
    params: GuidedV2ResultGroup,
  ): VNode | [] => {

      const {resultGroupName, resultGroupOpenUrl, links}: GuidedV2ResultGroup = params;

      const emitters = params?.eventEmitters() ?? undefined;
      let emitter;

      if(emitters == undefined){
        emitter = () => {
          console.log('emitter is undefined'); //eslint-disable-line
        };
      }else{
        emitter = ()=>{
            emitters.sectionChanged.emit({label: resultGroupName});
        };
      }

      if(!links || links.length == 0)
        return [];

      return <div class="guided-v2-result-list-section__section add-selector-strength">
        {
          resultGroupName &&
        <div class="guided-v2-result-list-section__section-title add-selector-strength">
          <qds-web-title-link
            text={resultGroupName} size=""
            href={resultGroupOpenUrl}
            icon-name="chevron-right"
            onClick={emitter}
          ></qds-web-title-link>
        </div>
        }
        <ul class="guided-v2-result-list-section__links add-selector-strength">
          {links.map(params.strategyLinkRenderer)}
        </ul>
      </div> as VNode;
  };
